import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "line-item-pricing" }
const _hoisted_2 = { class: "line-item-pricing__item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "line-item-pricing__label" }, "Type:", -1)
const _hoisted_4 = { class: "line-item-pricing__content" }
const _hoisted_5 = { class: "line-item-pricing__item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "line-item-pricing__label" }, "Quantity:", -1)
const _hoisted_7 = { class: "line-item-pricing__content" }
const _hoisted_8 = { class: "line-item-pricing__item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "line-item-pricing__label" }, "Price:", -1)
const _hoisted_10 = {
  key: 0,
  class: "line-item-pricing__content"
}
const _hoisted_11 = {
  key: 0,
  class: "text-strikethrough"
}
const _hoisted_12 = {
  key: 1,
  class: "line-item-pricing__content"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "line-item-pricing__item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "line-item-pricing__label" }, "Extended:", -1)
const _hoisted_17 = {
  key: 0,
  class: "line-item-pricing__content"
}
const _hoisted_18 = {
  key: 1,
  class: "line-item-pricing__content"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("span", {
          class: _normalizeClass({ 'text-strikethrough': _ctx.showDiscountInfo })
        }, _toDisplayString(_ctx.variant), 3),
        _createTextVNode("   "),
        (_ctx.showDiscountInfo)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(_ctx.discountedPriceClass)
            }, _toDisplayString(_ctx.alternateVariant), 3))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("li", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.lineItem.quantity), 1)
    ]),
    _createElementVNode("li", _hoisted_8, [
      _hoisted_9,
      (_ctx.showDiscountInfo)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
            (_ctx.hasLyftDiscount || _ctx.hasSubscriptionDiscount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.preDiscountUnitPrice), 1))
              : _createCommentVNode("", true),
            _createTextVNode("   "),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.discountedPriceClass)
            }, _toDisplayString(_ctx.unitPriceCents), 3)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_12, [
            (_ctx.discountsApplied)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.preDiscountUnitPrice), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.unitPriceCents), 1))
          ]))
    ]),
    _createElementVNode("li", _hoisted_15, [
      _hoisted_16,
      (_ctx.showDiscountInfo)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
            _createElementVNode("span", {
              class: _normalizeClass({ 'text-strikethrough': _ctx.hasLyftDiscount || _ctx.hasSubscriptionDiscount })
            }, _toDisplayString(_ctx.preDiscountExtendedPrice), 3),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.discountedPriceClass)
            }, _toDisplayString(_ctx.extendedPrice), 3)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_18, [
            (_ctx.discountsApplied)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.preDiscountExtendedPrice), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.extendedPrice), 1))
          ]))
    ])
  ]))
}